import { StockTransferListComponent } from './stock-transfer-list.component';

export default StockTransferListComponent;
